"use client"

import { LeafyGreen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LeafyGreenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LeafyGreenIcon = component(Icon)({ as: LeafyGreen })
